export class GitMergeResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "state",
            "baseName": "state",
            "type": "MergeState",
            "format": ""
        },
        {
            "name": "mergeCommitSha",
            "baseName": "mergeCommitSha",
            "type": "string",
            "format": ""
        },
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        },
        {
            "name": "reason",
            "baseName": "reason",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GitMergeResult.attributeTypeMap;
    }
    constructor() {
    }
}
